'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.gamification = void 0;
var adapter_1 = require("../adapter");
var Gamification = /** @class */ (function () {
    function Gamification() {
    }
    /**
     * Returns leaderboard-like result of participants based on the provided
     * in the request achievement and the respectful participants value.
     * The endpoint can limit the leaderboard result by sending the "limit"
     * property or by using pagination. The endpoint has a 30s cache.
     */
    Gamification.prototype.leaderboard = function (options) {
        return adapter_1.adapter.gamification.leaderboard(options);
    };
    /**
     * Depending on the value of `fullDetails` boolean parameter it returns:
     * if it's false, just a number representing the value achieved by the user
     * if it's true, a full set of information regarding the specified achievement.
     */
    Gamification.prototype.achievement = function (params) {
        return adapter_1.adapter.gamification.achievement(params);
    };
    /**
     * Collects the data when a game is clicked and send them to the Magic.
     */
    Gamification.prototype.collectGameClickEvents = function (params) {
        return adapter_1.adapter.gamification.collectGameClickEvents(params);
    };
    return Gamification;
}());
exports.gamification = new Gamification();
